// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"f297110a","221":"f744d45a","357":"86c20a46","447":"e5a6e105","453":"eb9b73df","497":"10fc9b07","617":"4f3257fb","638":"26c39274","752":"8e6958b6","780":"53aa2873","859":"0b59172d"}[chunkId] + ".chunk.js";
};